document.addEventListener('DOMContentLoaded', () => {

  const body = document.body;

  /* -----------------------------
  Drawer Open
  ----------------------------- */

  const openTrigger = document.querySelector('.iconfilter_trigger');
  const drawer = document.querySelector('.filter_mobile_drawer');
  const closeTrigger = document.querySelector('.close_drawer_trigger');

  if (openTrigger && drawer) {
    openTrigger.addEventListener('click', () => {
      drawer.classList.add('open');
      body.classList.add('filter-drawer-open');
    });
  }

  if (closeTrigger && drawer) {
    closeTrigger.addEventListener('click', () => {
      drawer.classList.remove('open');
      body.classList.remove('filter-drawer-open');
    });
  }

  /* -----------------------------
  Global Click Handler
  (works for desktop + mobile)
  ----------------------------- */

  document.addEventListener('click', (e) => {

    /* collapse toggle */

    const toggle = e.target.closest('.js-filter-toggle');

    if (toggle) {
      const group = toggle.closest('.filter-group');

      if (group) {
        group.classList.toggle('open');
      }

      return;
    }

    /* checkbox navigation */

    const checkbox = e.target.closest('.filter-checkbox');

    if (checkbox) {

      const url = checkbox.dataset.url;

      if (url) {
        window.location.href = url;
      }

      return;
    }

  });

});